// When translating new text, make sure to update the translations too:
// https://mdcollab.atlassian.net/wiki/spaces/engineering/pages/680329381/Localization
export type {SupportedLanguage, TranslateFn} from "./types";
export {DEFAULT_LANG, I18nNamespace} from "./constants";
export {createServerTranslation} from "./i18n.server";
export {default as Trans} from "./Trans";
